<template>
  <div class="page">
    <p class="page-container">请使用微信扫码</p>
  </div>
</template>
<style scoped>
.page {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -150px 0 0 -200px;
  width: 400px;
  height: 300px;
}
.page-container {
  font-size: 25px;
  text-align: center;
  color: rgb(192, 204, 218);
}
.router-link-active {
  font-size: 14px;
}
</style>
<script>
export default {
  components: {},
  directives: {},
  data() {
    return {};
  },
  created() {},
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
